import * as React from 'react';
import { styled } from '@mui/material/styles';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import { AppContext } from '../../context/AppContext';
import { NewOrderSummary } from '../../pages/Orders/NewOrderSummary';
import { SupplierNotesHistory } from '../../pages/Orderhistory/SupplierNotesHistory';
import { StoreNotesHistory } from '../../pages/Orderhistory/StoreNotesHistory';
import { ViewImage } from '../../pages/Products/ViewImage';

export interface BakeasyDialogProps {
  dialog?: BakeasyDialogProp;
}

export interface BakeasyDialogProp {
  isDelete?: boolean | false;
  open?: boolean;
  title?: string;
  message?: string;
  dialogContent?: any;
  onYesClick?: (
    event: React.MouseEvent<HTMLButtonElement>,
    param?: string
  ) => void;
  onNoClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': { padding: theme.spacing(2) },
  '& .MuiDialogActions-root': { padding: theme.spacing(1) },
}));

export default function BakeasyDialog(props: BakeasyDialogProps) {
  let myContext = React.useContext(AppContext);
  const [maxWidth, setMaxWidth] = React.useState<DialogProps['maxWidth']>('lg');

  function handleOnClose() {
    myContext.setDialog({ open: false });
  }

  React.useEffect(() => {
    const pageName = props?.dialog?.dialogContent?.pageName;

    if (pageName === 'NewOrderSummary') {
      setMaxWidth('lg');
    } else {
      setMaxWidth('sm');
    }
  }, [props?.dialog?.dialogContent?.pageName]);

  function renderUI(pageName: string) {
    switch (pageName) {
      case 'NewOrderSummary':
        return <>{renderNewOrderSummary()}</>;
      case 'supplierNotesHistory':
        return <>{renderSupplierDialog()}</>;
      case 'storeNotesHistory':
        return <>{renderStoreDialog()}</>;
      case 'ViewImage':
        return <>{renderViewImage()}</>;
    }
  }

  function renderNewOrderSummary() {
    return <NewOrderSummary isEdit={props?.dialog?.dialogContent} />;
  }

  function renderSupplierDialog() {
    return (
      <SupplierNotesHistory from={props?.dialog?.dialogContent?.params?.from} />
    );
  }

  function renderStoreDialog() {
    return (
      <StoreNotesHistory
        from={props?.dialog?.dialogContent?.params?.from}
        fetchMethod={props?.dialog?.dialogContent?.params?.fetchMethod}
      />
    );
  }

  function renderViewImage() {
    return <ViewImage {...props?.dialog?.dialogContent} />;
  }

  return (
    <React.Fragment>
      <BootstrapDialog
        fullWidth={maxWidth === 'sm'}
        maxWidth={maxWidth}
        onClose={handleOnClose}
        aria-labelledby="customized-dialog-title"
        open={props?.dialog?.open ? props?.dialog?.open : false}
      >
        {renderUI(props?.dialog?.dialogContent?.pageName)}
      </BootstrapDialog>
    </React.Fragment>
  );
}
